import { AdressesLabel, IAddresses, ICreateAddress } from '../types/Adresses';

const GUEST_ADDRESS_KEY = 'guest_address';
export const GUEST_ADDRESS_ID = 'guest-address';

export const getGuestAddressPayload = (): ICreateAddress | null => {
  try {
    const raw = localStorage.getItem(GUEST_ADDRESS_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? (parsed as ICreateAddress) : null;
  } catch {
    return null;
  }
};

export const saveGuestAddressPayload = (body: ICreateAddress) => {
  localStorage.setItem(GUEST_ADDRESS_KEY, JSON.stringify(body));
};

export const clearGuestAddressPayload = () => {
  localStorage.removeItem(GUEST_ADDRESS_KEY);
};

// Mirrors the same (lat,lng)/dom-kod-kv-dop_nomer mapping addressesAdapter.ts
// applies to a real backend record, so a guest address displays identically
// before and after it gets synced to the backend once the user logs in.
export const guestAddressFromPayload = (body: ICreateAddress): IAddresses => {
  const [lat, lon] = body.geo.split(',').map(Number);

  return {
    _id: GUEST_ADDRESS_ID,
    title: body.title,
    location: {
      lat: lat || 0,
      lon: lon || 0,
    },
    details: {
      entrance: body.dom || '',
      intercom: body.kod || '',
      floor: body.dop_nomer || '',
      apartment: body.kv || '',
      comment: body.comment || '',
    },
    label_type: (body.type as AdressesLabel) || undefined,
  };
};
